export const homePage = "/manpower/data";
